// src/components/public/ThemeDock.js
// The floating brown / green switch on the public pages (landing, support). The theme itself lives in hooks/useAppTheme.
import React, { useEffect, useState } from "react";

const DOCK_KEY = "pref-theme-dock";

export default function ThemeDock({ theme, setTheme }) {
  const [side, setSide] = useState(() => {
    try {
      return localStorage.getItem(DOCK_KEY) === "right" ? "right" : "left";
    } catch {
      return "left";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(DOCK_KEY, side);
    } catch {}
  }, [side]);

  const other = side === "left" ? "right" : "left";

  return (
    <div className={`theme-dock ${side}`} role="group" aria-label="Theme picker" style={{ zIndex: 1200 }}>
      <button
        className={`dock-dot dot-brown ${theme === "brown" ? "active" : ""}`}
        onClick={() => setTheme("brown")}
        title="Use Brown (original) theme"
        aria-label="Use Brown (original) theme"
      />
      <button
        className={`dock-dot dot-green ${theme === "green" ? "active" : ""}`}
        onClick={() => setTheme("green")}
        title="Use Green theme"
        aria-label="Use Green theme"
      />
      <button className="dock-side-toggle" onClick={() => setSide(other)} title={`Move dock to ${other} side`} aria-label={`Move dock to ${other} side`}>
        ↔
      </button>
    </div>
  );
}
